import React, { useState } from 'react';
import { FaBullhorn } from 'react-icons/fa';

const FormulaPartnerCard = ({ compact = false }) => {
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <div className="bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-600 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-500 flex flex-col items-center justify-center w-full aspect-[1/2]">
        <div className="text-center p-6">
          <div className="w-16 h-16 bg-gray-300 dark:bg-gray-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <FaBullhorn className="text-2xl text-gray-400 dark:text-gray-300" />
          </div>
          <p className="text-sm font-medium text-gray-500 dark:text-gray-400 mb-1">
            Reklam Alanı
          </p>
          <p className="text-lg font-bold text-gray-600 dark:text-gray-300">
            300 x 600
          </p>
          <p className="text-xs text-gray-400 dark:text-gray-500 mt-3">
            Half Page Ad
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`w-full aspect-[1/2] rounded-xl overflow-hidden bg-black border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-[1.01] group ${compact ? 'max-w-[300px] max-h-[520px] mx-auto' : ''}`}>
      <a
        href="https://www.instagram.com/sauenerjiteknolojileri/"
        target="_blank"
        rel="noopener noreferrer"
        className="block w-full h-full relative"
        aria-label="SETTxSAUFormula Instagram sayfasına git"
      >
        <img
          src="/media/partners/sett-sau-formula.png"
          alt="SETTxSAUFormula Sponsorluk Afişi"
          className="w-full h-full object-contain"
          loading="lazy"
          onLoad={() => setHasError(false)}
          onError={(e) => {
             // Sadece gercekten error varsa
             setHasError(true);
          }}
        />
        {/* Overlay for subtle interaction */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-white/5 transition-colors duration-300 pointer-events-none" />
      </a>
    </div>
  );
};

export default FormulaPartnerCard;
